import "./index.css";
import { useState, useEffect } from "react";
import { useRecoilState } from "recoil";
import { rsToken, rsAddress, rsOrderPrint } from "./RecoilStates";

import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
  Outlet,
} from "react-router-dom";
import { Grid } from "@mui/material";
import Login from "./auth/Login/Login";
import MenuCom from "./main/menu/MenuCom";
import Header from "./main/header/Header";
import Dashboard from "./dashboard/Dashboard";

import Brand from "./basic-information/brand/Brand";
import EditBrand from "./basic-information/brand/EditBrand";
import AddBrand from "./basic-information/brand/AddBrand";

import ProductType from "./basic-information/productType/ProductType";
import EditProductType from "./basic-information/productType/EditProductType";
import AddProductType from "./basic-information/productType/AddProductType";

import ProductSize from "./basic-information/productSize/ProductSize";
import EditProductSize from "./basic-information/productSize/EditProductSize";
import AddProductSize from "./basic-information/productSize/AddProductSize";

import ProductColor from "./basic-information/productColor/ProductColor";
import EditProductColor from "./basic-information/productColor/EditProductColor";
import AddProductColor from "./basic-information/productColor/AddProductColor";

import ProductTaste from "./basic-information/productTaste/ProductTaste";
import EditProductTaste from "./basic-information/productTaste/EditProductTaste";
import AddProductTaste from "./basic-information/productTaste/AddProductTaste";

import Countries from "./basic-information/Countries/Countries";
import EditCountry from "./basic-information/Countries/EditCountry";
import AddCountry from "./basic-information/Countries/AddCountry";

import Company from "./basic-information/company/Company";
import EditCompany from "./basic-information/company/EditCompany";
import AddCompany from "./basic-information/company/AddCompany";

import ProductCategory from "./basic-information/productCategory/ProductCategory";
import EditProductCategory from "./basic-information/productCategory/EditProductCategory";
import AddProductCategory from "./basic-information/productCategory/AddProductCategory";

import ProductShield from "./basic-information/productShield/ProductShield";
import EditProductShield from "./basic-information/productShield/EditProductShield";
import AddProductShield from "./basic-information/productShield/AddProductShield";

import TargetLocation from "./basic-information/productTarget/TargetLocation";
import EditTargetLocation from "./basic-information/productTarget/EditTargetLocation";
import AddTargetLocation from "./basic-information/productTarget/AddTargetLocation";

import ProductMaterial from "./basic-information/productMaterial/ProductMaterial";
import EditProductMaterial from "./basic-information/productMaterial/EditProductMaterial";
import AddProductMaterial from "./basic-information/productMaterial/AddProductMaterial";

import Smell from "./basic-information/smell/Smell";
import EditSmell from "./basic-information/smell/EditSmell";
import AddSmell from "./basic-information/smell/AddSmell";

import Ingredients from "./basic-information/ingredients/Ingredients";
import EditIngredients from "./basic-information/ingredients/EditIngredients";
import AddIngredients from "./basic-information/ingredients/AddIngredients";

import ProductUsage from "./basic-information/productUsage/ProductUsage";
import EditProductUsage from "./basic-information/productUsage/EditProductUsage";
import AddProductUsage from "./basic-information/productUsage/AddProductUsage";

import Model from "./basic-information/productModel/Model";
import EditModel from "./basic-information/productModel/EditModel";
import AddModel from "./basic-information/productModel/AddModel";

import Highlight from "./basic-information/highlights/Highlight";
import EditHighlight from "./basic-information/highlights/EditHighlight";
import AddHighlight from "./basic-information/highlights/AddHighlight";

import ProductGroup from "./basic-information/productGroup/ProductGroup";
import AddProductGroup from "./basic-information/productGroup/AddProductGroup";
import AddChildProductGroup from "./basic-information/productGroup/AddChildProductGroup";
import EditProductGroup from "./basic-information/productGroup/EditProductGroup";

import Product from "./products/product/Product";
import EditProduct from "./products/product/EditProduct";
import AddProduct from "./products/product/AddProduct";
import SlaveProduct from "./products/slaveProduct/SlaveProduct";
import AddSlaveProduct from "./products/slaveProduct/AddSlaveProduct";
import FAQ from "./products/FAQ/FAQ";
import EditFAQ from "./products/FAQ/EditFAQ";
import EditFAQRow from "./products/FAQ/EditFAQRow";
import AddFAQ from "./products/FAQ/AddFAQ";

import Competitors from "./products/Competitors/Competitors";
import EditCompetitors from "./products/Competitors/EditCompetitors";
import AddOneCompetitor from "./products/Competitors/AddOneCompetitor";
import EditOneCompetitor from "./products/Competitors/EditOneCompetitor";

import Pictures from "./products/PicturesHandling/Pictures";
import EditPicture from "./products/PicturesHandling/EditPicture";
import Users from "./Users/User/Users";
import EditUser from "./Users/User/EditUser";
import Access from "./Users/Access/Access";
import NotPermission from "./Users/Access/NotPermission";

import Expertreview from "./products/Review/Expertreview";
import EditExpert from "./products/Review/EditExpert";
import Setting from "./main/header/Setting";

import FirstPageContent from "./ContentManagement/firstPage/FirstPageContent";

import HomeMagazines from "./ContentManagement/firstPage/HomeMagazine/Magazines";

import HomeLanding from "./ContentManagement/firstPage/HomeLanding/Landings";
import EditLanding from "./ContentManagement/firstPage/HomeLanding/EditLanding";
import AddLanding from "./ContentManagement/firstPage/HomeLanding/AddLanding";
import EditLandItem from "./ContentManagement/firstPage/HomeLanding/EditLandItem";
import AddLandItem from "./ContentManagement/firstPage/HomeLanding/AddLandItem";

import HomeCategory from "./ContentManagement/firstPage/HomeCategory/Categories";
import EditCategoryItem from "./ContentManagement/firstPage/HomeCategory/EditCategoryItem";
import AddCategoryItem from "./ContentManagement/firstPage/HomeCategory/AddCategoryItem";

import HomeOffer from "./ContentManagement/firstPage/HomeOffer/Offers";
import AddProductOff from "./ContentManagement/firstPage/HomeOffer/AddProductOff";

import HomeAdvertisings from "./ContentManagement/firstPage/HomeAdvertising/HomeAdvertisings";
import AddAdv from "./ContentManagement/firstPage/HomeAdvertising/AddAdv";
import EditAdv from "./ContentManagement/firstPage/HomeAdvertising/EditAdv";

import HomeSlides from "./ContentManagement/firstPage/HomeSlide/HomeSlides";
import AddSlide from "./ContentManagement/firstPage/HomeSlide/AddSlide";
import EditSlide from "./ContentManagement/firstPage/HomeSlide/EditSlide";

import MenuContent from "./ContentManagement/menu/MenuContent";
import EditMenu from "./ContentManagement/menu/EditMenu";
import AddMenu from "./ContentManagement/menu/AddMenu";

import Orders from "./ordersCom/OrdersPage/Orders";
import OrderDetail from "./ordersCom/detail/OrderDetail";
import AddOrder from "./ordersCom/addOrder/AddOrder";
import AddressPrint from "./ordersCom/detail/AddressPrint";
import FactorPrint from "./ordersCom/detail/FactorPrint";

import CommentsManagement from "./Communication/commentsManagement/CommentsManagement";
import Comments from "./Communication/comments/Comments";
import Reminder from "./Communication/reminder/Reminder";

import Articles from "./ContentManagement/articles/Articles";
import AddArticle from "./ContentManagement/articles/AddArticle";
import EditArticle from "./ContentManagement/articles/EditArticle";

import Writers from "./ContentManagement/writers/Writers";
import AddWriter from "./ContentManagement/writers/AddWriter";
import EditWriter from "./ContentManagement/writers/EditWriter";

import ArticleGroups from "./ContentManagement/articleGroups/ArticleGroups";
import AddArticleGroups from "./ContentManagement/articleGroups/AddArticleGroups";
import EditArticleGroups from "./ContentManagement/articleGroups/EditArticleGroups";

import DiscountManagment from "./products/discountManagment/DiscountManagment";
import DirectDiscountList from "./products/discountManagment/Direct/DirectDiscountList";
import BatchDiscountList from "./products/discountManagment/Batch/BatchDiscountList";
import DiscountCode from "./products/discountManagment/Code/DiscountCode";
import AddDiscountCode from "./products/discountManagment/Code/AddDiscountCode";
import EditDiscountCode from "./products/discountManagment/Code/EditDiscountCode";
import CandidateList from "./products/discountManagment/CandidateList";

import OrdersReport from "./Reports/Orders/OrdersReport";
import OrderReportDetails from "./Reports/Orders/Details/OrderReportDetails";

import GeneralPages from "./ContentManagement/GeneralPagesManagement/GeneralPages";
import PageDetail from "./ContentManagement/GeneralPagesManagement/PageDetails/PageDetail";
import AddPageContent from "./ContentManagement/GeneralPagesManagement/PageDetails/content/AddPageContent";
import EditPageContent from "./ContentManagement/GeneralPagesManagement/PageDetails/content/EditPageContent";
import EditPageContact from "./ContentManagement/GeneralPagesManagement/PageDetails/contact/EditPageContact";
import AddPageContact from "./ContentManagement/GeneralPagesManagement/PageDetails/contact/AddPageContact";
import EditPageFAQ from "./ContentManagement/GeneralPagesManagement/PageDetails/FAQ/EditPageFAQ";
import AddPageFAQ from "./ContentManagement/GeneralPagesManagement/PageDetails/FAQ/AddPageFAQ";

import ProductManagment from "./products/productManagment/ProductManagment";
import ProductGiftsList from "./products/GiftsManagment/ProductGift/ProductGiftsList";

import HomeComments from "./ContentManagement/firstPage/HomeComment/HomeComments";

import Product4 from "./ContentManagement/firstPage/Product4&5/Product4";
import AddGroupProduct from "./ContentManagement/firstPage/Product4&5/Group/AddGroupProduct";
import EditGroupProduct from "./ContentManagement/firstPage/Product4&5/Group/EditGroupProduct";

import SellReport from "./Reports/Sell/SellReport";

import Userswallet from "./ordersCom/userswallet/Userswallet";
import WalletManage from "./ordersCom/walletManagMent/WalletManage";
import AddWalletOffer from "./ordersCom/walletManagMent/AddWalletOffer";
import EditWalletOffer from "./ordersCom/walletManagMent/EditWalletOffer";

import WalletReport from "./Reports/wallet/WalletReport";

import FavoritProduct from "./Reports/Favorit/FavoritProduct";

import LandingPages from "./ContentManagement/landings/LandingPages";
import AddLandingPage from "./ContentManagement/landings/AddLandingPage";
import EditLandingPage from "./ContentManagement/landings/EditLandingPage";
import LandingPageContent from "./ContentManagement/landings/LandingPageContent";

import SendSMS from "./Communication/sendSMS/SendSMS";

import HeaderManage from "./ContentManagement/firstPage/HeaderCom/HeaderManage";
import FooterManage from "./ContentManagement/firstPage/FooterCom/FooterManage";
import EditCertificate from "./ContentManagement/firstPage/FooterCom/Certificate/EditCertificate";
import AddCertificate from "./ContentManagement/firstPage/FooterCom/Certificate/AddCertificate";
import EditLink from "./ContentManagement/firstPage/FooterCom/Links/EditLink";
import AddLink from "./ContentManagement/firstPage/FooterCom/Links/AddLink";
import AddNetwork from "./ContentManagement/firstPage/FooterCom/Networks/AddNetwork";
import EditNetwork from "./ContentManagement/firstPage/FooterCom/Networks/EditNetwork";
import EditList from "./ContentManagement/firstPage/FooterCom/List/EditList";
import AddList from "./ContentManagement/firstPage/FooterCom/List/AddList";
import AddListItem from "./ContentManagement/firstPage/FooterCom/List/AddListItem";
import EditListItem from "./ContentManagement/firstPage/FooterCom/List/EditListItem";
import EditCommunication from "./ContentManagement/firstPage/FooterCom/Communication/EditCommunication";
import AddCommunication from "./ContentManagement/firstPage/FooterCom/Communication/AddCommunication";

import BankTerminals from "./ordersCom/BankManagment/BankTerminals";

import Deliverycalendar from "./ordersCom/delivery calendar/Deliverycalendar";

import Ordergifts from "./products/GiftsManagment/OrderGift/Ordergifts";
import EditOrderGift from "./products/GiftsManagment/OrderGift/EditOrderGift";
import AddOrderGift from "./products/GiftsManagment/OrderGift/AddOrderGift";

import DriversManage from "./Logestic/Drivers/DriversManage";
import DeliveryManage from "./Logestic/deliveryManage/DeliveryManage";
import MotorRouting from "./Logestic/motorrouting/MotorRouting";
import MotorDelivery from "./Logestic/motorDelivery/MotorDelivery";

import RelatedProductList from "./products/relatedProduct/RelatedProductList";

import OrderPrint from "./Logestic/motorDelivery/OrderPrint";

import MagManagment from "./Mag-Content/MagManagment";
import MagSlides from "./Mag-Content/mag-Slide/MagSlides";
import AddMagSlide from "./Mag-Content/mag-Slide/AddMagSlide";
import EditMagSlide from "./Mag-Content/mag-Slide/EditMagSlide";
import MagLandings from "./Mag-Content/mag-Landing/MagLandings";
import AddGroupLanding from "./Mag-Content/mag-Landing/Group/AddGroupLanding";
import EditGroupLanding from "./Mag-Content/mag-Landing/Group/EditGroupLanding";

import MagHeaderManage from "./Mag-Content/mag-Header/MagHeaderManage";
import MagFooterManage from "./Mag-Content/mag-Footer/MagFooterManage";
import EditMagLink from "./Mag-Content/mag-Footer/Links/EditMagLink";
import AddMagLink from "./Mag-Content/mag-Footer/Links/AddMagLink";
import AddMagNetwork from "./Mag-Content/mag-Footer/Networks/AddMagNetwork";
import EditMagNetwork from "./Mag-Content/mag-Footer/Networks/EditMagNetwork";

import MagAdvertisment from "./Mag-Content/mag-Adv/MagAdvertisment";
import AddMagAdv from "./Mag-Content/mag-Adv/AddMagAdv";
import EditMagAdv from "./Mag-Content/mag-Adv/EditMagAdv";

import RelatedArticle from "./ContentManagement/relatedArticle/RelatedArticle";
import AddRelatedArticle from "./ContentManagement/relatedArticle/AddRelatedArticle";

import CustomerRetention from "./Marketing/Customer/CustomerRetention";
import AddPattern from "./Marketing/Customer/AddPattern";
import EditPattern from "./Marketing/Customer/EditPattern";
import EditCampaign from "./Marketing/Customer/EditCampaign";
import AddCampaign from "./Marketing/Customer/AddCampaign";
import ProductCluster from "./basic-information/productCluster/ProductCluster";
import EditCluster from "./basic-information/productCluster/EditCluster";
import AddCluster from "./basic-information/productCluster/AddCluster";
import CustomersManagement from "./Communication/Customers/CustomersManagement";
import Clusters from "./ContentManagement/firstPage/HomeCluster/Clusters";
import UserPollManagment from "./Communication/user-PollManagment/UserPollManagment";
import AddPoll from "./Communication/user-PollManagment/AddPoll";
import EditPoll from "./Communication/user-PollManagment/EditPoll";
import B2BCustomers from "./Marketing/B2BCustomer/B2BCustomers";
import EditCustomer from "./Marketing/B2BCustomer/EditCustomer";
import B2BOrders from "./Marketing/B2BOrders/B2BOrders";
import EditB2BOffer from "./Marketing/B2BOrders/offer/EditB2BOffer";
import AddB2BOffer from "./Marketing/B2BOrders/offer/AddB2BOffer";
import ShortLink from "./basic-information/shortLink/ShortLink";
import AddShortLink from "./basic-information/shortLink/AddShortLink";
import EditShortLink from "./basic-information/shortLink/EditShortLink";
import DeliveryReport from "./Reports/delivery/DeliveryReport";
import useBreakpoints from "./hooks/useBreakpoints";
import B2BOrderReport from "./Reports/b2b/B2BOrderReport";
import AdvertismentGroup from "./advertisment/adv-group/AdvertismentGroup";
import AddAdvGroup from "./advertisment/adv-group/AddAdvGroup";
import EditAdvGroup from "./advertisment/adv-group/EditAdvGroup";
import Advertisments from "./advertisment/advertisments/Advertisments";
import AddAdvertisment from "./advertisment/advertisments/AddAdvertisment";
import EditAdvertisment from "./advertisment/advertisments/EditAdvertisment";
import AdvertisingManage from "./advertisment/advertisingManage/AdvertisingManage";
import AddAdvManage from "./advertisment/advertisingManage/AddAdvManage";
import EditAdvManage from "./advertisment/advertisingManage/EditAdvManage";
import AddContract from "./advertisment/adv-contract/AddContract";
import EditContract from "./advertisment/adv-contract/EditContract";
import AdvertismentContract from "./advertisment/adv-contract/AdvertismentContract";
import AddAdvCustomer from "./advertisment/adv-customers/AddAdvCustomer";
import EditAdvCustomer from "./advertisment/adv-customers/EditAdvCustomer";
import AdvCustomers from "./advertisment/adv-customers/AdvCustomers";
import AdvFactorPrint from "./advertisment/adv-contract/AdvFactorPrint";
import PagesVisitReport from "./Reports/pagevisit/PagesVisitReport";
import SearchAdvertisment from "./ContentManagement/searchAdvmanage/SearchAdvertisment";
import ExpressManage from "./Logestic/expressDelivery/ExpressManage";
import ExpressDetails from "./Logestic/expressDelivery/ExpressDetails";
import LandingHeaderManage from "./ContentManagement/landings/HeaderLanding/LandingHeaderManage";
import LandingFooterManage from "./ContentManagement/landings/FooterCom/LandingFooterManage";
import AddTopBanner from "./ContentManagement/firstPage/HeaderCom/AddTopBanner";
import EditTopBanner from "./ContentManagement/firstPage/HeaderCom/EditTopBanner";
import PaymentManagment from "./ordersCom/Payment/PaymentManagment";
import EditPayment from "./ordersCom/Payment/EditPayment";
import InstallmentOrderReport from "./Reports/installment-order/InstallmentOrderReport";
import ConsultantOrdersReport from "./Reports/consultantOrders/ConsultantOrdersReport";
import ExpressOrderReport from "./Reports/express-order/ExpressOrderReport";
import ExpressOrderDetails from "./Reports/express-order/ExpressOrderDetails";
import Supplier from "./commerce/suppliers/Supplier";
import EditSupplier from "./commerce/suppliers/EditSupplier";
import AddSupplier from "./commerce/suppliers/AddSupplier";
import SuppliersList from "./commerce/suppliers-products/SuppliersList";
import EditSupplierProducts from "./commerce/suppliers-products/EditSupplierProducts";
import SupplierRequests from "./commerce/supplier-request/SupplierRequests";
import EditRequest from "./commerce/supplier-request/EditRequest";
import AddRequest from "./commerce/supplier-request/AddRequest";
import SupplierOffers from "./commerce/supplier-offer/SupplierOffers";
import SupplierOrders from "./commerce/supplier-order/SupplierOrders";
import AddSupplierOrder from "./commerce/supplier-order/AddSupplierOrder";
import Consulators from "./Communication/consulators/Consulators";
import ManageConsultants from "./Communication/manage-consultants/ManageConsultants";
import AddConsultantClients from "./Communication/manage-consultants/AddConsultantClients";
import Consultation from "./Communication/consultation/Consultation";
import ConsultationDetail from "./Communication/consultation/ConsultationDetail";
import ManageConsulators from "./Communication/manage-consulators/ManageConsulators";
import ConsulatorDetail from "./Communication/manage-consulators/ConsulatorDetail";
import DiscountCodeReports from "./Reports/discountCode/DiscountCodeReports";
import { Test } from "./test/Test";
import FestivalManagment from "./Marketing/Festival-Managment/FestivalManagment";
import EditFestival from "./Marketing/Festival-Managment/EditFestival";
import AddFestival from "./Marketing/Festival-Managment/AddFestival";
import OrderDeliveryDetails from "./Reports/delivery/OrderDeliveryDetails";
import FractionalList from "./ordersCom/fractionalList/FractionalList";
import FractionalOrders from "./ordersCom/fractionalList/FractionalOrders";
import ProductVideos from "./products/ProductVideos/ProductVideos";
import ProductVideoDetail from "./products/ProductVideos/ProductVideoDetail";

function getFaviconEl() {
  return document.getElementById("favicon");
}

function App() {
  const [msToken, setMsToken] = useRecoilState(rsToken);
  const [msAddress, setMsAddress] = useRecoilState(rsAddress);
  const [msOrderPrint, setMsOrderPrint] = useRecoilState(rsOrderPrint);
  const { isSmall } = useBreakpoints();

  const clearCacheData = () => {
    let configVersion = window.ENV.versionCode;
    let LSVersion = localStorage.getItem("VersionCode");

    if (LSVersion == null && configVersion) {
      window.location.reload(true);
      localStorage.setItem("VersionCode", configVersion);
    } else if (LSVersion !== configVersion) {
      window.location.reload(true);
      localStorage.setItem("VersionCode", configVersion);
    } else if (LSVersion === configVersion) {
    }
  };

  useEffect(() => {
    const favicon = getFaviconEl();
    favicon.href = window.ENV.icon;
    clearCacheData();
  }, []);

  return (
    <Router forceRefresh={true}>
      <Grid container sx={{ height: "100vh" }}>
        {msToken && !msAddress && !msOrderPrint && <MenuCom></MenuCom>}
        <Grid
          sx={{ height: "100%" }}
          item
          xs={msToken && !msAddress && !isSmall ? 10 : 12}
        >
          {msToken && !msAddress && !msOrderPrint && <Header></Header>}

          <Routes>
            <Route element={<PrivateRoute token={msToken} />}>
              {/* <Route path="/test" element={<Test></Test>}></Route> */}
              <Route path="/" element={<Dashboard></Dashboard>}></Route>
              <Route path="/setting" element={<Setting></Setting>}></Route>
              <Route path="/brands" element={<Brand></Brand>}></Route>
              <Route
                path="/brands/addbrand"
                element={<AddBrand></AddBrand>}
              ></Route>
              <Route
                path="/brands/editbrand"
                element={<EditBrand></EditBrand>}
              ></Route>
              <Route
                path="/producttypes"
                element={<ProductType></ProductType>}
              ></Route>
              <Route
                path="/producttypes/addproducttype"
                element={<AddProductType></AddProductType>}
              ></Route>
              <Route
                path="/producttypes/editproducttype"
                element={<EditProductType></EditProductType>}
              ></Route>
              <Route
                path="/productsize"
                element={<ProductSize></ProductSize>}
              ></Route>
              <Route
                path="/productsize/addproductsize"
                element={<AddProductSize></AddProductSize>}
              ></Route>
              <Route
                path="/productsize/editproductsize"
                element={<EditProductSize></EditProductSize>}
              ></Route>
              <Route
                path="/productcolors"
                element={<ProductColor></ProductColor>}
              ></Route>
              <Route
                path="/productcolors/addproductcolor"
                element={<AddProductColor></AddProductColor>}
              ></Route>
              <Route
                path="/productcolors/editproductcolor"
                element={<EditProductColor></EditProductColor>}
              ></Route>
              <Route
                path="/producttaste"
                element={<ProductTaste></ProductTaste>}
              ></Route>
              <Route
                path="/producttaste/addproducttaste"
                element={<AddProductTaste></AddProductTaste>}
              ></Route>
              <Route
                path="/producttaste/editproducttaste"
                element={<EditProductTaste></EditProductTaste>}
              ></Route>
              <Route
                path="/Countries"
                element={<Countries></Countries>}
              ></Route>
              <Route
                path="/Countries/addcountry"
                element={<AddCountry></AddCountry>}
              ></Route>
              <Route
                path="/Countries/editcountry"
                element={<EditCountry></EditCountry>}
              ></Route>
              <Route path="/companies" element={<Company></Company>}></Route>
              <Route
                path="/companies/addCompany"
                element={<AddCompany></AddCompany>}
              ></Route>
              <Route
                path="/companies/editcompany"
                element={<EditCompany></EditCompany>}
              ></Route>
              <Route
                path="/categories"
                element={<ProductCategory></ProductCategory>}
              ></Route>
              <Route
                path="/categories/addcategory"
                element={<AddProductCategory></AddProductCategory>}
              ></Route>
              <Route
                path="/categories/editcategory"
                element={<EditProductCategory></EditProductCategory>}
              ></Route>
              <Route
                path="/productshield"
                element={<ProductShield></ProductShield>}
              ></Route>
              <Route
                path="/productshield/addproductshield"
                element={<AddProductShield></AddProductShield>}
              ></Route>
              <Route
                path="/productshield/editproductshield"
                element={<EditProductShield></EditProductShield>}
              ></Route>
              <Route
                path="/targetlocation"
                element={<TargetLocation></TargetLocation>}
              ></Route>
              <Route
                path="/targetlocation/addtargetlocation"
                element={<AddTargetLocation></AddTargetLocation>}
              ></Route>
              <Route
                path="/targetlocation/edittargetlocation"
                element={<EditTargetLocation></EditTargetLocation>}
              ></Route>
              <Route
                path="/targetlocation"
                element={<TargetLocation></TargetLocation>}
              ></Route>
              <Route
                path="/targetlocation/addtargetlocation"
                element={<AddTargetLocation></AddTargetLocation>}
              ></Route>
              <Route
                path="/targetlocation/edittargetlocation"
                element={<EditTargetLocation></EditTargetLocation>}
              ></Route>
              <Route
                path="/productmaterial"
                element={<ProductMaterial></ProductMaterial>}
              ></Route>
              <Route
                path="/productmaterial/addmaterial"
                element={<AddProductMaterial></AddProductMaterial>}
              ></Route>
              <Route
                path="/productmaterial/editmaterial"
                element={<EditProductMaterial></EditProductMaterial>}
              ></Route>
              <Route path="/productscent" element={<Smell></Smell>}></Route>
              <Route
                path="/productscent/addproductscent"
                element={<AddSmell></AddSmell>}
              ></Route>
              <Route
                path="/productscent/editproductscent"
                element={<EditSmell></EditSmell>}
              ></Route>
              <Route
                path="/appropriate"
                element={<ProductUsage></ProductUsage>}
              ></Route>
              <Route
                path="/appropriate/editAppropriate"
                element={<EditProductUsage></EditProductUsage>}
              ></Route>
              <Route
                path="/appropriate/addAppropriate"
                element={<AddProductUsage></AddProductUsage>}
              ></Route>
              <Route
                path="/ingredients"
                element={<Ingredients></Ingredients>}
              ></Route>
              <Route
                path="/ingredients/addingredient"
                element={<AddIngredients></AddIngredients>}
              ></Route>
              <Route
                path="/ingredients/editingredients"
                element={<EditIngredients></EditIngredients>}
              ></Route>
              <Route path="/models" element={<Model></Model>}></Route>
              <Route
                path="/models/addmodel"
                element={<AddModel></AddModel>}
              ></Route>
              <Route
                path="/models/editmodel"
                element={<EditModel></EditModel>}
              ></Route>
              <Route
                path="/highlights"
                element={<Highlight></Highlight>}
              ></Route>
              <Route
                path="/highlights/addhighlight"
                element={<AddHighlight></AddHighlight>}
              ></Route>
              <Route
                path="/highlights/edithighlight"
                element={<EditHighlight></EditHighlight>}
              ></Route>
              <Route path="/productgroups" element={<ProductGroup />}></Route>
              <Route
                path="/productgroups/addproductGroup"
                element={<AddProductGroup />}
              ></Route>
              <Route
                path="/productgroups/addChildproductgroup"
                element={<AddChildProductGroup />}
              ></Route>
              <Route
                path="/productgroups/editproductgroup"
                element={<EditProductGroup />}
              ></Route>
              <Route path="/products" element={<Product></Product>}></Route>
              <Route
                path="/products/addproduct"
                element={<AddProduct></AddProduct>}
              ></Route>
              <Route
                exact
                path="/products/editproduct"
                element={<EditProduct></EditProduct>}
              ></Route>
              <Route
                path="/slaveproducts"
                element={<SlaveProduct></SlaveProduct>}
              ></Route>
              <Route
                path="/slaveproducts/addslaveproduct"
                element={<AddSlaveProduct></AddSlaveProduct>}
              ></Route>
              <Route
                path="/competitors"
                element={<Competitors></Competitors>}
              ></Route>
              <Route
                path="/competitors/editcompetitors"
                element={<EditCompetitors></EditCompetitors>}
              ></Route>
              <Route
                path="/competitors/editcompetitors/addOneCompetitor"
                element={<AddOneCompetitor></AddOneCompetitor>}
              ></Route>
              <Route
                path="/competitors/editcompetitors/editOneCompetitor"
                element={<EditOneCompetitor></EditOneCompetitor>}
              ></Route>
              <Route
                path="/productimages/editpicture"
                element={<EditPicture />}
              ></Route>
              <Route path="/productimages" element={<Pictures />}></Route>
              <Route path="/users" element={<Users />}></Route>
              <Route path="/users/edituser" element={<EditUser />}></Route>
              <Route path="/useraccess" element={<Access />}></Route>
              <Route path="/notPermission" element={<NotPermission />}></Route>
              <Route path="/faq" element={<FAQ />}></Route>
              <Route path="/faq/editfaq" element={<EditFAQ />}></Route>
              <Route path="/faq/addfaq" element={<AddFAQ />}></Route>
              <Route
                path="/faq/editfaq/editfaqrow"
                element={<EditFAQRow />}
              ></Route>
              <Route
                path="/expertreview"
                element={<Expertreview></Expertreview>}
              ></Route>
              <Route
                path="/expertreview/editexpert"
                element={<EditExpert></EditExpert>}
              ></Route>
              <Route
                path="/homepagemanage"
                element={<FirstPageContent></FirstPageContent>}
              ></Route>
              <Route
                path="/LandingsManage"
                element={<HomeLanding></HomeLanding>}
              ></Route>
              <Route
                path="/LandingsManage/editLanding"
                element={<EditLanding></EditLanding>}
              ></Route>
              <Route
                path="/LandingsManage/addLanding"
                element={<AddLanding></AddLanding>}
              ></Route>
              <Route
                path="/LandingsManage/addItem"
                element={<AddLandItem></AddLandItem>}
              ></Route>
              <Route
                path="/LandingsManage/editItem"
                element={<EditLandItem></EditLandItem>}
              ></Route>
              <Route
                path="/MagazineManage"
                element={<HomeMagazines></HomeMagazines>}
              ></Route>
              <Route
                path="/CategoriesManage"
                element={<HomeCategory></HomeCategory>}
              ></Route>
              <Route
                path="/CategoriesManage/addItem"
                element={<AddCategoryItem></AddCategoryItem>}
              ></Route>
              <Route
                path="/CategoriesManage/editItem"
                element={<EditCategoryItem></EditCategoryItem>}
              ></Route>

              <Route
                path="/ProductOffers"
                element={<HomeOffer></HomeOffer>}
              ></Route>
              <Route
                path="/ProductOffers/AddProduct"
                element={<AddProductOff></AddProductOff>}
              ></Route>
              <Route
                path="/advertisingmanagement"
                element={<HomeAdvertisings></HomeAdvertisings>}
              ></Route>
              <Route
                path="/advertisingmanagement/addAdvertising"
                element={<AddAdv></AddAdv>}
              ></Route>
              <Route
                path="/advertisingmanagement/editAdvertising"
                element={<EditAdv></EditAdv>}
              ></Route>
              <Route
                path="/SlidesManage"
                element={<HomeSlides></HomeSlides>}
              ></Route>
              <Route
                path="/SlidesManage/addSlide"
                element={<AddSlide></AddSlide>}
              ></Route>
              <Route
                path="/SlidesManage/editSlide"
                element={<EditSlide></EditSlide>}
              ></Route>
              <Route
                path="/menues"
                element={<MenuContent></MenuContent>}
              ></Route>
              <Route
                path="/menues/editMenu"
                element={<EditMenu></EditMenu>}
              ></Route>
              <Route
                path="/menues/addMenu"
                element={<AddMenu></AddMenu>}
              ></Route>
              <Route path="/orders" element={<Orders></Orders>}></Route>
              <Route
                path="/orders/orderDetail"
                element={<OrderDetail></OrderDetail>}
              ></Route>
              <Route
                path="/ordermodify"
                element={<AddOrder></AddOrder>}
              ></Route>
              <Route
                path="/orders/orderDetail/addressPrint"
                element={<AddressPrint />}
              ></Route>
              <Route
                path="/orders/orderDetail/factorPrint"
                element={<FactorPrint />}
              ></Route>
              <Route
                path="/managecomments"
                element={<CommentsManagement />}
              ></Route>
              <Route path="/comments" element={<Comments />}></Route>
              <Route path="/articles" element={<Articles />}></Route>
              <Route
                path="/articles/addArticle"
                element={<AddArticle />}
              ></Route>
              <Route
                path="/articles/editArticle"
                element={<EditArticle />}
              ></Route>
              <Route path="/authors" element={<Writers />}></Route>
              <Route path="/authors/addAuthors" element={<AddWriter />}></Route>
              <Route
                path="/authors/editAuthors"
                element={<EditWriter />}
              ></Route>
              <Route path="/articlegroups" element={<ArticleGroups />}></Route>
              <Route
                path="/articlegroups/addArticleGroup"
                element={<AddArticleGroups />}
              ></Route>
              <Route
                path="/articlegroups/editArticleGroup"
                element={<EditArticleGroups />}
              ></Route>
              <Route
                path="/discountmanagment"
                element={<DiscountManagment />}
              ></Route>
              <Route
                path="/discountmanagment/directDiscount"
                element={<DirectDiscountList />}
              ></Route>
              <Route
                path="/discountmanagment/batchDiscount"
                element={<BatchDiscountList />}
              ></Route>
              <Route
                path="/discountmanagment/discountCode"
                element={<DiscountCode />}
              ></Route>
              <Route
                path="/discountmanagment/discountCode/addCode"
                element={<AddDiscountCode />}
              ></Route>
              <Route
                path="/discountmanagment/discountCode/editCode"
                element={<EditDiscountCode />}
              ></Route>
              <Route
                path="/discountmanagment/candidateList"
                element={<CandidateList />}
              ></Route>
              <Route path="/ordersreport" element={<OrdersReport />}></Route>
              <Route
                path="/ordersreport/OrderReportDetails"
                element={<OrderReportDetails />}
              ></Route>
              <Route path="/generalpages" element={<GeneralPages />}></Route>
              <Route
                path="/generalpages/pageDetail"
                element={<PageDetail />}
              ></Route>
              <Route
                path="/generalpages/pageDetail/addPageContent"
                element={<AddPageContent />}
              ></Route>
              <Route
                path="/generalpages/pageDetail/editPageContent"
                element={<EditPageContent />}
              ></Route>
              <Route
                path="/generalpages/pageDetail/editPageContact"
                element={<EditPageContact />}
              ></Route>
              <Route
                path="/generalpages/pageDetail/addPageContact"
                element={<AddPageContact />}
              ></Route>
              <Route
                path="/generalpages/pageDetail/editPageFAQ"
                element={<EditPageFAQ />}
              ></Route>
              <Route
                path="/generalpages/pageDetail/addPageFAQ"
                element={<AddPageFAQ />}
              ></Route>
              <Route
                path="/productstorage"
                element={<ProductManagment />}
              ></Route>
              <Route
                path="/CommentsManage"
                element={<HomeComments></HomeComments>}
              ></Route>
              <Route
                path="/ProductsOfferManage"
                element={<Product4></Product4>}
              ></Route>
              <Route
                path="/ProductsOfferManage/AddGroup"
                element={<AddGroupProduct></AddGroupProduct>}
              ></Route>
              <Route
                path="/ProductsOfferManage/EditGroup"
                element={<EditGroupProduct></EditGroupProduct>}
              ></Route>
              <Route
                path="/productgifts"
                element={<ProductGiftsList />}
              ></Route>
              <Route path="/productreport" element={<SellReport />}></Route>
              <Route path="/reminder" element={<Reminder />}></Route>
              <Route path="/userswallet" element={<Userswallet />}></Route>
              <Route path="/walletManagment" element={<WalletManage />}></Route>
              <Route
                path="/walletManagment/addWalletOffer"
                element={<AddWalletOffer />}
              ></Route>
              <Route
                path="/walletManagment/editWalletOffer"
                element={<EditWalletOffer />}
              ></Route>
              <Route path="/walletreport" element={<WalletReport />}></Route>
              <Route
                path="/favoritproducts"
                element={<FavoritProduct />}
              ></Route>
              <Route
                path="/landingmanagment"
                element={<LandingPages />}
              ></Route>
              <Route
                path="/landingmanagment/addLandinPage"
                element={<AddLandingPage />}
              ></Route>
              <Route
                path="/landingmanagment/editLandinPage"
                element={<EditLandingPage />}
              ></Route>
              <Route
                path="/landingmanagment/landingComponents"
                element={<LandingPageContent />}
              ></Route>
              <Route path="/manualsms" element={<SendSMS />}></Route>
              <Route path="/headerManage" element={<HeaderManage />}></Route>
              <Route
                path="/headerManage/addTopBanner"
                element={<AddTopBanner />}
              ></Route>
              <Route
                path="/headerManage/editTopBanner"
                element={<EditTopBanner />}
              ></Route>
              <Route path="/footerManage" element={<FooterManage />}></Route>
              <Route
                path="/footerManage/editCertificate"
                element={<EditCertificate />}
              ></Route>
              <Route
                path="/footerManage/addCertificate"
                element={<AddCertificate />}
              ></Route>
              <Route
                path="/footerManage/editLink"
                element={<EditLink />}
              ></Route>
              <Route path="/footerManage/addLink" element={<AddLink />}></Route>
              <Route
                path="/footerManage/editNetwork"
                element={<EditNetwork />}
              ></Route>
              <Route
                path="/footerManage/addNetwork"
                element={<AddNetwork />}
              ></Route>
              <Route
                path="/footerManage/editList"
                element={<EditList />}
              ></Route>
              <Route path="/footerManage/addList" element={<AddList />}></Route>
              <Route
                path="/footerManage/editList/editItem"
                element={<EditListItem />}
              ></Route>
              <Route
                path="/footerManage/editList/addItem"
                element={<AddListItem />}
              ></Route>
              <Route
                path="/footerManage/editCommunication"
                element={<EditCommunication />}
              ></Route>
              <Route
                path="/footerManage/addCommunication"
                element={<AddCommunication />}
              ></Route>
              <Route path="/bankterminals" element={<BankTerminals />}></Route>
              <Route
                path="/deliverycalendar"
                element={<Deliverycalendar />}
              ></Route>
              <Route path="/ordergifts" element={<Ordergifts />}></Route>
              <Route
                path="/ordergifts/editOrdergifts"
                element={<EditOrderGift />}
              ></Route>
              <Route
                path="/ordergifts/addOrdergifts"
                element={<AddOrderGift />}
              ></Route>
              <Route path="/drivermanage" element={<DriversManage />}></Route>
              <Route
                path="/deliverymanage"
                element={<DeliveryManage />}
              ></Route>
              <Route path="/motorrouting" element={<MotorRouting />}></Route>
              <Route path="/motordelivery" element={<MotorDelivery />}></Route>
              <Route
                path="/motordelivery/OrderPrint"
                element={<OrderPrint />}
              ></Route>
              <Route
                path="/relatedproducts"
                element={<RelatedProductList />}
              ></Route>
              <Route path="/magmanagment" element={<MagManagment />}></Route>
              <Route
                path="/magmanagment/SlidesManage"
                element={<MagSlides />}
              ></Route>
              <Route
                path="/magmanagment/SlidesManage/addSlide"
                element={<AddMagSlide />}
              ></Route>
              <Route
                path="/magmanagment/SlidesManage/editSlide"
                element={<EditMagSlide />}
              ></Route>
              <Route
                path="/magmanagment/LandingsManage"
                element={<MagLandings />}
              ></Route>
              <Route
                path="/magmanagment/LandingsManage/AddGroup"
                element={<AddGroupLanding />}
              ></Route>
              <Route
                path="/magmanagment/LandingsManage/EditGroup"
                element={<EditGroupLanding />}
              ></Route>
              <Route
                path="/magHeaderManage"
                element={<MagHeaderManage />}
              ></Route>
              <Route
                path="/magFooterManage"
                element={<MagFooterManage />}
              ></Route>
              <Route
                path="/magFooterManage/editLink"
                element={<EditMagLink />}
              ></Route>
              <Route
                path="/magFooterManage/addLink"
                element={<AddMagLink />}
              ></Route>
              <Route
                path="/magFooterManage/editNetwork"
                element={<EditMagNetwork />}
              ></Route>
              <Route
                path="/magFooterManage/addNetwork"
                element={<AddMagNetwork />}
              ></Route>
              <Route path="/magadvmanage" element={<MagAdvertisment />}></Route>
              <Route
                path="/magadvmanage/addMagAdv"
                element={<AddMagAdv />}
              ></Route>
              <Route
                path="/magadvmanage/editMagAdv"
                element={<EditMagAdv />}
              ></Route>
              <Route
                path="/relatedarticle"
                element={<RelatedArticle />}
              ></Route>
              <Route
                path="/relatedarticle/addRelatedArticle"
                element={<AddRelatedArticle />}
              ></Route>
              <Route
                path="/customerretention"
                element={<CustomerRetention />}
              ></Route>
              <Route
                path="/customerretention/addPattern"
                element={<AddPattern />}
              ></Route>
              <Route
                path="/customerretention/editPattern"
                element={<EditPattern />}
              ></Route>
              <Route
                path="/customerretention/addCampaign"
                element={<AddCampaign />}
              ></Route>
              <Route
                path="/customerretention/editCampaign"
                element={<EditCampaign />}
              ></Route>
              <Route
                path="/productcluster"
                element={<ProductCluster />}
              ></Route>
              <Route
                path="/productcluster/editCluster"
                element={<EditCluster />}
              ></Route>
              <Route
                path="/productcluster/addCluster"
                element={<AddCluster />}
              ></Route>
              <Route
                path="/customers"
                element={<CustomersManagement />}
              ></Route>
              <Route
                path="/ProductsClusterManage"
                element={<Clusters />}
              ></Route>
              <Route
                path="/userpollmanagment"
                element={<UserPollManagment />}
              ></Route>
              <Route
                path="/userpollmanagment/addPoll"
                element={<AddPoll />}
              ></Route>
              <Route
                path="/userpollmanagment/editPoll"
                element={<EditPoll />}
              ></Route>
              <Route path="/b2bcustomers" element={<B2BCustomers />}></Route>
              <Route
                path="/b2bcustomers/editCustomer"
                element={<EditCustomer />}
              ></Route>
              <Route path="/b2borders" element={<B2BOrders />}></Route>
              <Route
                path="/b2borders/addB2BOffer"
                element={<AddB2BOffer />}
              ></Route>
              <Route
                path="/b2borders/editB2BOffer"
                element={<EditB2BOffer />}
              ></Route>
              <Route path="/shortlink" element={<ShortLink />}></Route>
              <Route
                path="/shortlink/addShortLink"
                element={<AddShortLink />}
              ></Route>
              <Route
                path="/shortlink/editShortLink"
                element={<EditShortLink />}
              ></Route>
              <Route
                path="/deliveryreport"
                element={<DeliveryReport />}
              ></Route>
              <Route
                path="/deliveryreport/details"
                element={<OrderDeliveryDetails />}
              ></Route>
              <Route
                path="/b2borderreport"
                element={<B2BOrderReport />}
              ></Route>
              <Route
                path="/advertismentgroup"
                element={<AdvertismentGroup />}
              ></Route>
              <Route
                path="/advertismentgroup/addgroup"
                element={<AddAdvGroup />}
              ></Route>
              <Route
                path="/advertismentgroup/editgroup"
                element={<EditAdvGroup />}
              ></Route>
              <Route path="/advertisments" element={<Advertisments />}></Route>
              <Route
                path="/advertisments/addAdvertisment"
                element={<AddAdvertisment />}
              ></Route>
              <Route
                path="/advertisments/editAdvertisment"
                element={<EditAdvertisment />}
              ></Route>
              <Route
                path="/advertisingmanage"
                element={<AdvertisingManage />}
              ></Route>
              <Route
                path="/advertisingmanage/addAdvertisingManage"
                element={<AddAdvManage />}
              ></Route>
              <Route
                path="/advertisingmanage/editAdvertisingManage"
                element={<EditAdvManage />}
              ></Route>
              <Route
                path="/advertismentcontract"
                element={<AdvertismentContract />}
              ></Route>
              <Route
                path="/advertismentcontract/addAdvertismentContract"
                element={<AddContract />}
              ></Route>
              <Route
                path="/advertismentcontract/editAdvertismentContract"
                element={<EditContract />}
              ></Route>
              <Route
                path="/advertismentcontract/factorPrint"
                element={<AdvFactorPrint />}
              ></Route>
              <Route
                path="/advertismentcustomers"
                element={<AdvCustomers />}
              ></Route>
              <Route
                path="/advertismentcustomers/addAdvCustomer"
                element={<AddAdvCustomer />}
              ></Route>
              <Route
                path="/advertismentcustomers/editAdvCustomer"
                element={<EditAdvCustomer />}
              ></Route>
              <Route path="/pagevisit" element={<PagesVisitReport />}></Route>
              <Route
                path="/searchadvmanage"
                element={<SearchAdvertisment />}
              ></Route>
              <Route path="/expressmanage" element={<ExpressManage />}></Route>
              <Route
                path="/expressmanage/orderDetail"
                element={<ExpressDetails />}
              ></Route>
              <Route
                path="/landingmanagment/headerManage"
                element={<LandingHeaderManage />}
              ></Route>
              <Route
                path="/landingmanagment/footerManage"
                element={<LandingFooterManage />}
              ></Route>
              <Route
                path="/paymentmanagment"
                element={<PaymentManagment />}
              ></Route>
              <Route
                path="/paymentmanagment/editPayment"
                element={<EditPayment />}
              ></Route>
              <Route
                path="/installmentreports"
                element={<InstallmentOrderReport />}
              ></Route>
              <Route
                path="/consulatororders"
                element={<ConsultantOrdersReport />}
              ></Route>
              <Route path="/consulators" element={<Consulators />}></Route>
              <Route
                path="/expressorderreports"
                element={<ExpressOrderReport />}
              ></Route>
              <Route
                path="/expressorderreports/orderDetail"
                element={<ExpressOrderDetails />}
              ></Route>
              <Route path="/suppliers" element={<Supplier />}></Route>
              <Route
                path="/suppliers/editSupplier"
                element={<EditSupplier />}
              ></Route>
              <Route
                path="/suppliers/addSupplier"
                element={<AddSupplier />}
              ></Route>
              <Route
                path="/supplierproducts"
                element={<SuppliersList />}
              ></Route>
              <Route
                path="/supplierproducts/editSupplierProduct"
                element={<EditSupplierProducts />}
              ></Route>
              <Route
                path="/supplierrequest"
                element={<SupplierRequests />}
              ></Route>
              <Route
                path="/supplierrequest/editRequest"
                element={<EditRequest />}
              ></Route>
              <Route
                path="/supplierrequest/addRequest"
                element={<AddRequest />}
              ></Route>
              <Route
                path="/supplieroffers"
                element={<SupplierOffers />}
              ></Route>
              <Route
                path="/supplierorders"
                element={<SupplierOrders />}
              ></Route>
              <Route
                path="/supplierorders/addOrder"
                element={<AddSupplierOrder />}
              ></Route>
              <Route
                path="/manageconsulate"
                element={<ManageConsultants />}
              ></Route>
              <Route
                path="/manageconsulate/addClients"
                element={<AddConsultantClients />}
              ></Route>
              <Route path="/consulate" element={<Consultation />}></Route>
              <Route
                path="/consulate/consultationDetails"
                element={<ConsultationDetail />}
              ></Route>
              <Route
                path="/manageconsulators"
                element={<ManageConsulators />}
              ></Route>
              <Route
                path="/manageconsulators/consulatorDetail"
                element={<ConsulatorDetail />}
              ></Route>
              <Route
                path="/discountcodereports"
                element={<DiscountCodeReports />}
              ></Route>
              <Route
                path="/festivalmanagment"
                element={<FestivalManagment />}
              ></Route>
              <Route
                path="/festivalmanagment/editFestival"
                element={<EditFestival />}
              ></Route>
              <Route
                path="/festivalmanagment/addFestival"
                element={<AddFestival />}
              ></Route>
              <Route
                path="/fractionallist"
                element={<FractionalList />}
              ></Route>
              <Route
                path="/fractionallist/orders"
                element={<FractionalOrders />}
              ></Route>
              <Route path="/productvideos" element={<ProductVideos />}></Route>
              <Route
                path="/productvideos/details"
                element={<ProductVideoDetail />}
              ></Route>
            </Route>
            <Route path="/login" element={<Login />}></Route>
          </Routes>
        </Grid>
      </Grid>
    </Router>
  );
}

function PrivateRoute({ children, ...rest }) {
  const [msToken, setMsToken] = useRecoilState(rsToken);

  return msToken && msToken !== null && msToken !== "" ? (
    <Outlet />
  ) : (
    <Navigate to="/login" />
  );
}

export default App;
